export const buildWhatsAppLink = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const formatMXN = (value) => {
  const num = Number(value || 0);
  const hasCents = Math.round(num * 100) % 100 !== 0;
  return `$${num.toLocaleString("es-MX", { minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: hasCents ? 2 : 0 })} MXN`;
};
